import { render, staticRenderFns } from "./home.vue?vue&type=template&id=2f62fc53"
import script from "./home.ts?vue&type=script&lang=js&external"
export * from "./home.ts?vue&type=script&lang=js&external"
import style0 from "./home.vue?vue&type=style&index=0&id=2f62fc53&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports